import { DEFAULT_DROP_DOWN_FONT_SIZE } from './defaultTextDefaultValue.ts';
import { RowTypesIdentifier, TotalRowTypesIdentifier } from './table.types.ts';
import type { HeadingLevelProps } from '../../GridDndEditor/TiptapEditor/TipTapBarMenu/Heading.tsx';

export const headingTableLevels: Record<string, HeadingLevelProps> = {
  table_header_row: {
    fontSize: DEFAULT_DROP_DOWN_FONT_SIZE,
    title: 'editor.toolbar.table_header',
    isFontWeightBold: false,
    rowType: RowTypesIdentifier.HEADER,
    dataAttribute: 'table_header_row',
  },
  table_body_row: {
    fontSize: DEFAULT_DROP_DOWN_FONT_SIZE,
    title: 'editor.toolbar.table_body',
    isFontWeightBold: false,
    rowType: RowTypesIdentifier.BODY,
    dataAttribute: 'table_body_row',
  },
  table_footer_row: {
    fontSize: DEFAULT_DROP_DOWN_FONT_SIZE,
    title: 'editor.toolbar.table_footer',
    isFontWeightBold: false,
    rowType: RowTypesIdentifier.FOOTER,
    dataAttribute: 'table_footer_row',
  },
  table_subtotal_row: {
    fontSize: DEFAULT_DROP_DOWN_FONT_SIZE,
    title: 'editor.toolbar.table_subtotal',
    isFontWeightBold: false,
    rowType: TotalRowTypesIdentifier.SUBTOTAL,
    dataAttribute: 'table_subtotal_row',
  },
  table_total_row: {
    fontSize: DEFAULT_DROP_DOWN_FONT_SIZE,
    title: 'editor.toolbar.table_total',
    isFontWeightBold: false,
    rowType: TotalRowTypesIdentifier.TOTAL,
    dataAttribute: 'table_total_row',
  },
};
export const DATA_TABLE_STYLE = 'data-table-style';
export const DATA_STYLE_SET = 'data-style-set';
